import { useSelector } from 'react-redux';
import { Star, Zap, TrendingUp, Gift } from 'lucide-react';

const StatCard = ({ icon: Icon, label, value, color, bg }) => (
    <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center gap-3">
        <div className={`w-10 h-10 rounded-full ${bg} flex items-center justify-center flex-shrink-0`}>
            <Icon className={`w-5 h-5 ${color}`} />
        </div>
        <div>
            <p className="text-xl font-bold text-gray-900 leading-none">{value}</p>
            <p className="text-xs text-gray-500 mt-0.5">{label}</p>
        </div>
    </div>
);

const RewardsCredits = () => {
    const { userInfo } = useSelector(s => s.auth);

    return (
        <div className="space-y-3">
            {/* Stats */}
            <div className="grid grid-cols-3 md:grid-cols-1 gap-3">
                <StatCard icon={Star}       label="Reward Points"  value="0"        color="text-orange-500" bg="bg-orange-50" />
                <StatCard icon={Zap}        label="Promo Credits"  value="AED 0.00" color="text-blue-500"   bg="bg-blue-50" />
                <StatCard icon={TrendingUp} label="Total Earned"   value="0"        color="text-green-500"  bg="bg-green-50" />
            </div>

            {/* Member card */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="bg-orange-500 px-5 py-5 flex items-center justify-between">
                    <div>
                        <p className="text-white/70 text-xs font-medium uppercase tracking-wide">Member</p>
                        <p className="text-white text-lg font-bold mt-1">{userInfo?.name || 'Customer'}</p>
                        <p className="text-white/70 text-xs mt-0.5">{userInfo?.email || ''}</p>
                    </div>
                    <Gift className="w-10 h-10 text-white/30" />
                </div>
                <div className="px-5 py-3 border-t border-gray-100 flex items-center justify-between">
                    <p className="text-xs text-gray-500">Membership Tier</p>
                    <p className="text-xs font-semibold text-gray-800">Standard</p>
                </div>
            </div>

            {/* Activity */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
                    <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
                        Rewards Activity
                    </span>
                </div>
                <div className="flex flex-col items-center py-12">
                    <Gift className="w-9 h-9 text-gray-300 mb-2" />
                    <p className="text-sm text-gray-500 font-medium">No activity yet</p>
                    <p className="text-xs text-gray-400 mt-1">Points appear here after eligible purchases</p>
                </div>
            </div>
        </div>
    );
};

export default RewardsCredits;
